'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollView } from "react-native";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { ModalContainer } from "./ModalContainer";
import { Text } from "./Text";
import { View } from "./View";
import { Shadow, useTheme } from "../styles";
/**
 * @nosync
 */ export function FormModalNoPadding(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(View, {
        style: {
            marginHorizontal: -24
        },
        children: children
    });
}
/**
 * Renders a modal view that contains a form. Handles scrolling for tall
 * content.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-82}
 */ export function FormModal(props) {
    var theme = useTheme().theme;
    var _props_minWidth, _props_minWidth1, _props_maxWidth, _props_cancelText, _props_confirmText;
    return /*#__PURE__*/ _jsxs(ModalContainer, {
        testID: props.testID,
        visible: props.visible,
        onRequestClose: function() {},
        style: [
            {
                minWidth: (_props_minWidth = props.minWidth) !== null && _props_minWidth !== void 0 ? _props_minWidth : 340,
                maxWidth: (_props_maxWidth = props.maxWidth) !== null && _props_maxWidth !== void 0 ? _props_maxWidth : Math.max(600, (_props_minWidth1 = props.minWidth) !== null && _props_minWidth1 !== void 0 ? _props_minWidth1 : 0),
                width: '100%',
                marginVertical: 'auto',
                backgroundColor: 'white',
                marginHorizontal: 10,
                borderRadius: 20,
                paddingVertical: 24,
                paddingHorizontal: 24
            },
            Shadow.high
        ],
        children: [
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    marginBottom: 20,
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ _jsxs(View, {
                        spacing: 10,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                text: props.title,
                                size: 20,
                                weight: "bold"
                            }),
                            props.subtitle ? /*#__PURE__*/ _jsx(Text, {
                                color: theme.color.gray300,
                                text: props.subtitle,
                                size: 15
                            }) : null
                        ]
                    }),
                    props.onCancel ? /*#__PURE__*/ _jsx(Icon, {
                        name: "close",
                        onPress: props.onCancel,
                        size: 14,
                        "aria-label": "Close modal"
                    }) : null
                ]
            }),
            props.maxHeight ? /*#__PURE__*/ _jsx(ScrollView, {
                style: {
                    maxHeight: props.maxHeight,
                    marginHorizontal: -24,
                    paddingHorizontal: 24
                },
                children: /*#__PURE__*/ _jsx(View, {
                    style: {
                        width: '100%'
                    },
                    children: props.children
                })
            }) : /*#__PURE__*/ _jsx(View, {
                style: {
                    width: '100%'
                },
                children: props.children
            }),
            props.hideActions ? null : /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: props.onCancel ? 'space-between' : 'center',
                    marginTop: 14
                },
                children: [
                    props.onCancel ? /*#__PURE__*/ _jsx(Button, {
                        onPress: props.onCancel,
                        text: (_props_cancelText = props.cancelText) !== null && _props_cancelText !== void 0 ? _props_cancelText : 'Cancel',
                        variant: "text",
                        testID: props.cancelTestID,
                        style: {}
                    }) : null,
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: props.disableButton,
                        onPress: props.onConfirm,
                        text: (_props_confirmText = props.confirmText) !== null && _props_confirmText !== void 0 ? _props_confirmText : 'Save',
                        variant: "solid",
                        testID: props.confirmTestID
                    })
                ]
            })
        ]
    });
}
